export default "__VITE_ASSET__DD6HQHb3__"